import { render, staticRenderFns } from "./background-check-notify.vue?vue&type=template&id=552df6bc"
import script from "./background-check-notify.vue?vue&type=script&lang=js"
export * from "./background-check-notify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports